export default abstract class IInputMaskItem {
    /** The mask to display as a placeHolder */
    public abstract mask: string;

    public clear() {
        this.maskValue.forEach((mv) => (mv.userValue = null));
    }

    /** Each character in the mask with its placeHolder and current user value. User value should be NULL if no user input has been set */
    protected maskValue: MaskValue[] = [];

    /**
     * Tries to add a character to the mask
     * @param char The character being added to the mask
     * @param charIndex The index of the character being added to the mask
     * @return True if we set the value, false otherwis
     */
    public abstract addUserInput(char: string, charIndex: number): boolean;

    /**
     * Tries to remove a character from the mask
     * @param charIndex The index we want to remove at
     * @return True if a character was removed, false otherwise
     */
    public abstract removeUserInput(charIndex: number): boolean;

    /**
     * Get the current value we should display.
     * For the mask yyyy, with userinput 19, this should return 19yy
     */
    public abstract getCurrentDisplayValue(): string;

    /**
     * Get the current value we should display.
     * For the mask yyyy, with userinput 19, this should return '19  '
     */
    public abstract getCurrentTextForInputElement(isMaskFilled?: boolean): string;

    /**
     * Get the current value we should display.
     * For the mask yyyy, with userinput 19, this should return '19yy'
     */
    public getGrayMaskValue() {
        return this.getCurrentDisplayValue();
    }

    /**
     * Checks if the mask is filled
     * @return true if the mask is filled, false otherwise
     */
    public abstract isMaskFilled(): boolean;

    public findFirstUnfilledIndex() {
        return this.maskValue.findIndex((mv) => mv.userValue == null);
    }
}

export class MaskValue {
    placeHolder: string = '';
    userValue: string | null = null;

    constructor(placeHolder: string, userValue: string | null = null) {
        this.placeHolder = placeHolder;
        this.userValue = userValue;
    }
}
